var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[_c('p',[_vm._v("\n    "+_vm._s(new Date(_vm.params.data.date).toLocaleDateString('es-ES', _vm.dateStringOptions))+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }